type PDPSection = {
  id?: string;
  title: string;
  className?: string;
  description?: string;
  children?: React.ReactNode | React.ReactNode[];
};

export const Section = (props: PDPSection) => {
  const { id, title, children, className, description } = props;

  return (
    <div id={id} className={className}>
      <h2
        className={`!ui-text-2xl !ui-m-0 !ui-text-left ${
          !description ? '!ui-mb-4' : ''
        }`}
      >
        {title}
      </h2>
      {description && (
        <p className="!ui-text-base !ui-mt-1 !ui-mb-4">{description}</p>
      )}
      <div>{children}</div>
    </div>
  );
};
